import { Component, Input, Optional } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { CheckableRowsService } from '../../../services/table/checkable-rows/checkable-rows.service';
import { LsqDataTableComponent } from '../data-table/lsq-data-table.component';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-checkbox-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th cdk-header-cell *cdkHeaderCellDef class="checkable" [style.width]="column.width">
                <div class="th-content">
                    <lsq-checkbox
                        *ngIf="!hideSelectAll"
                        [id]="'header-checkbox-' + column.key"
                        [label]="''"
                        [ngModel]="checkableRowsService?.areAllRowsChecked()"
                        [disabled]="
                            disabled ||
                            dataTable?.disableTable ||
                            checkableRowsService?.isEmpty() ||
                            !checkableRowsService ||
                            (checkableRowsService.isLoading$ | async)
                        "
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="handleSelectAllChange($event)"
                    >
                    </lsq-checkbox>
                </div>
            </th>
            <td cdk-cell *cdkCellDef="let row" class="checkable" [style.width]="column.width">
                <lsq-checkbox
                    *ngIf="selectAllIncludesDisabled || !disableRow(row)"
                    [disabled]="
                        disabled ||
                        dataTable?.disableTable ||
                        disableRow(row) ||
                        !checkableRowsService
                    "
                    [ngModel]="checkableRowsService?.isRowChecked(row[column.key])"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="toggleRowCheckIfEnabled(row, row[column.key])"
                >
                </lsq-checkbox>

                <!-- Sometimes we don't want select all to check the disabled rows -->
                <lsq-checkbox
                    *ngIf="!selectAllIncludesDisabled && disableRow(row)"
                    [disabled]="true"
                    [ngModel]="false"
                    [ngModelOptions]="{ standalone: true }"
                >
                </lsq-checkbox>
            </td>
        </ng-container>
    `
})
export class LsqCheckboxColumnComponent extends LsqBaseColumnComponent {
    @Input() public checkableRowsService: CheckableRowsService;
    @Input() public disableRow: (row: any) => boolean = (row) => false;
    @Input() public disabled = false;
    @Input() public hideSelectAll = false;
    @Input() public selectAllIncludesDisabled = true;
    public readonly color = Color;

    constructor(@Optional() public dataTable: LsqDataTableComponent) {
        super(dataTable);
    }

    public handleSelectAllChange(): void {
        if (!this.checkableRowsService.areAllRowsChecked()) {
            this.checkableRowsService.checkAll();
        } else {
            this.checkableRowsService.uncheckAll();
        }
    }

    public toggleRowCheckIfEnabled(row: any, rowPrimaryKey: string): void {
        if (!this.disableRow(row)) {
            this.checkableRowsService.toggleCheck(rowPrimaryKey);
        }
    }
}
